import React from "react";
import { Switch, Route } from "react-router";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import App from "../containers/App";

import Home from "../containers/Home";
import UsersPage from "../containers/Users";
import DashboardPage from "../containers/DashboardPage";
import MatchDetailPage from "../containers/MatchDetailPage";
import AgentDetailPage from "../containers/AgentDetailPage";
import AdminReportManagement from "../containers/AdminReportManagement";
import SupportTicketsPage from "../containers/SupportTicketsPage";
import MarketingLeadsPage from "../containers/MarketingLeadsPage";
import MatchNightsPage from "../containers/MatchNightsPage";
import SupportTicketDetailPage from "../containers/SupportTicketDetailPage";
import ReputationOutcomesPage from "../containers/ReputationOutcomesPage";
import MembershipPage from "../containers/MembershipPage";
import AdminAccessPage from "../containers/AdminAccessPage";
import FinancePage from "../containers/FinancePage";
import AnticheatPage from "../containers/AnticheatPage";
import AnticheatDebuggerPage from "../containers/AnticheatDebuggerPage";
import GuardDevicesPage from "../containers/GuardDevicesPage";
import EmailCampaignsPage from "../containers/EmailCampaignsPage";
import CampaignAttributionPage from "../containers/CampaignAttributionPage";
import SocialEngagementPage from "../containers/SocialEngagementPage";
import TemplatesPage from "../containers/TemplatesPage";
import UiExperimentsPage from "../containers/UiExperimentsPage";

import PrivacyPolicyPage from "../containers/PrivacyPolicyPage";
import TermsOfUsePage from "../containers/TermsOfUsePage";
import AboutUsPage from "../containers/AboutUsPage";
import GDPRPage from "../containers/GdprPage";
import { ADMIN_ROLES, getDefaultAdminRoute, hasAdminRole } from "./adminRoles";

export const routes = [
  {
    path: "/",
    exact: true,
    component: Home,
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/dashboard",
    exact: true,
    component: DashboardPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/match/:matchId/details",
    exact: true,
    component: MatchDetailPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/agent/:agentKey/details",
    exact: true,
    component: AgentDetailPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/users",
    exact: true,
    component: UsersPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/reports/:reportId",
    exact: true,
    component: AdminReportManagement,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/reputation-outcomes/:steamId",
    exact: true,
    component: ReputationOutcomesPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/support-tickets",
    exact: true,
    component: SupportTicketsPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/marketing-leads",
    exact: true,
    component: MarketingLeadsPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/match-nights",
    exact: true,
    component: MatchNightsPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/support-tickets/:ticketId",
    exact: true,
    component: SupportTicketDetailPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/membership",
    exact: true,
    component: MembershipPage,
    allowedAdminRoles: [ADMIN_ROLES.REVIEW_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/finance",
    exact: true,
    component: FinancePage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/anticheat",
    exact: true,
    component: AnticheatPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/anticheat-debugger",
    exact: true,
    component: AnticheatDebuggerPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/guard",
    exact: true,
    component: GuardDevicesPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/access",
    exact: true,
    component: AdminAccessPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/email-campaigns",
    exact: true,
    component: EmailCampaignsPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/campaign-attribution",
    exact: true,
    component: CampaignAttributionPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/social-engagement",
    exact: true,
    component: SocialEngagementPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/templates",
    exact: true,
    component: TemplatesPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/admin/ui-experiments",
    exact: true,
    component: UiExperimentsPage,
    allowedAdminRoles: [ADMIN_ROLES.SUPER_ADMIN],
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/privacy",
    exact: true,
    component: PrivacyPolicyPage,
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/about-us",
    exact: true,
    component: AboutUsPage,
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/data-protection-policy-and-gdpr",
    exact: true,
    component: GDPRPage,
    loadData: () => () => Promise.resolve(),
  },
  {
    path: "/terms-of-use",
    exact: true,
    component: TermsOfUsePage,
    loadData: () => () => Promise.resolve(),
  },
  {
    component: Home,
  },
];

function GuardedRouteRendererBase({
  component: RouteComponent,
  allowedAdminRoles,
  user,
  ...routeProps
}) {
  if (
    allowedAdminRoles &&
    user?.userId &&
    !hasAdminRole(user, allowedAdminRoles)
  ) {
    return <Redirect to={getDefaultAdminRoute(user)} />;
  }

  return <RouteComponent {...routeProps} />;
}

const GuardedRouteRenderer = connect((state) => ({
  user: state.catalogReducer?.user,
}))(GuardedRouteRendererBase);

export default function Router() {
  return (
    <App>
      <Switch>
        {routes.map((route) => {
          const {
            component,
            allowedAdminRoles,
            loadData,
            ...routeProps
          } = route;

          return (
            <Route
              key={route.path || "notfound"}
              {...routeProps}
              render={(renderProps) => (
                <GuardedRouteRenderer
                  component={component}
                  allowedAdminRoles={allowedAdminRoles}
                  {...renderProps}
                />
              )}
            />
          );
        })}
      </Switch>
    </App>
  );
}
